export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6907.5c844b1f.jpg";